import { useCallback, useRef } from 'react';

/**
 * Une barre fixée en bas de l'écran PUBLIE sa hauteur mesurée dans
 * `--hauteur-barre-basse` (sur <html>) tant qu'elle est montée. Les boutons
 * flottants (WhatsApp, assistant, retour en haut) la lisent pour se poser
 * au-dessus au lieu de la recouvrir — l'assistant masquait la moitié droite de
 * « Demander un devis ». Repris de Locassio (`--hauteur-barre-action`) : une
 * hauteur écrite en dur diverge au premier libellé sur deux lignes.
 *
 * Renvoie une ref de rappel : elle suit le montage réel de la barre, même
 * quand celle-ci n'apparaît qu'après un chargement. Une barre `md:hidden`
 * mesure 0 sur ordinateur : rien ne bouge.
 */
export function useHauteurBarreBasse() {
  const observateur = useRef<ResizeObserver | null>(null);
  return useCallback((barre: HTMLElement | null) => {
    const racine = document.documentElement;
    observateur.current?.disconnect();
    observateur.current = null;
    if (!barre) {
      racine.style.removeProperty('--hauteur-barre-basse');
      return;
    }
    const publier = () =>
      racine.style.setProperty('--hauteur-barre-basse', `${Math.round(barre.getBoundingClientRect().height)}px`);
    publier();
    observateur.current = new ResizeObserver(publier);
    observateur.current.observe(barre);
  }, []);
}
